import type { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export function Table({ className, ...p }: HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="w-full overflow-x-auto">
      <table {...p} className={cn('w-full border-collapse text-sm', className)} />
    </div>
  );
}
export function THead(p: HTMLAttributes<HTMLTableSectionElement>) {
  return <thead {...p} className={cn('text-left text-xs text-muted', p.className)} />;
}
export function TBody(p: HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody {...p} />;
}
export function TR({ className, ...p }: HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      {...p}
      className={cn(
        'h-10 border-b border-border transition-colors last:border-b-0 hover:bg-hover/60',
        className,
      )}
    />
  );
}
export function TH({ className, ...p }: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th {...p} className={cn('h-9 border-b border-border px-3 font-medium whitespace-nowrap', className)} />
  );
}
export function TD({ className, ...p }: TdHTMLAttributes<HTMLTableCellElement>) {
  return <td {...p} className={cn('px-3 py-1.5 align-middle', className)} />;
}
